export const environment = {
    production: false,
    //baseURl: 'https://localhost:44337/api',
    //imagePath: 'https://localhost:44337/',
    baseURl: 'https://apidev.klinaro.com/api',
    imagePath: 'https://apidev.klinaro.com/'
};
